import { Typography } from "@mui/material";
import { Box, styled } from "@mui/system";



export const ButtonsContainer = styled(Box)({
  margin: '0 25px',
  marginTop: '10px',
  textAlign: 'center',
  "& .MuiButtonBase-root": {
    marginRight: '18px',
    height: '26px',
    fontSize: '12px',
  },
});
